import React, { FC} from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
} from '@mui/material';
import { 
  ImgBox,
  Typography700,
 } from 'views/rebranded-module/common/components';
import  StyledBox  from 'views/rebranded-module/membership-module/MembershipLandingViewV2/components/HeroSection/HeroSection.styles';
import  ClubIcon  from 'public/imgs/Rebranding/icons/ClubIcon';
import { RiCheckFill } from 'react-icons/ri';
import Typography500 from 'views/common/components/UI/Typography500';
import ScrollTo from 'lib/utils/ScrollTo';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const HeroSection: FC<any> = () => {
 const handleScrollToPlansComparison = () => {
  ScrollTo('plans-comparison-section', -60);
};
const getSizedImage = useAdabtiveMultiSizeImage();
const content = useContent('MembershipLandingPage');
return (
    <StyledBox>
      <Box className="HSBGContainer">
        <ImgBox
            image={{
                src: '/imgs/Rebranding/petterns/asphalt.png',
                alt: 'Asphalt background',

            }}
            width="100%"
            height="100%"
        />
        </Box>
        <Box className="HSContantContainer">
            <Container maxWidth="xl">
               <Grid container spacing={10}>
                      <Grid item lg={5.5} md={12} sm={12}>
                        <ClubIcon className="HSClubIcon"/>
                          <Typography700 component="p" variant="overline2" my={3} color="primary">
                              {content.heroSectionSubTitle}
                              </Typography700>
                          <Typography700 component="h1" variant="h1" mb={3}
                                dangerouslySetInnerHTML={{
                                  __html: content.heroSectionTitle
                                        }} />
                            
                            <Typography component="p" variant="body1"  color="text.secondary" mb={1}>
                              {content.heroSectionDescription}
                          </Typography>
                          <Box mb={4}>
                              {content.heroBenefitList.map((benefit, index) => (
                                  <Box className="HSBenfitItem" key={benefit.benefitText}>
                                    <RiCheckFill  className="HSBenfitItemIcon" />
                                    <Typography500 variant="body1" color="text.secondary">
                                      {benefit.benefitText}
                                    </Typography500>
                                  </Box>
                          ))}
                          </Box>

                       <Button
                          variant="contained"
                          color="primary"
                          size="large"
                        onClick={handleScrollToPlansComparison}
                        >
                            {content.joinClubBtn}
                        </Button>

                        </Grid>
                        <Grid item lg={6.5} md={12} sm={12} className="HSImageGrid">
                            <Box className="HSMembershipImage">
                             <ImgBox
                               image={{
                                    src: getSizedImage(content.heroBackground.sizes),
                                    alt: content.heroBackground.alt,
                                  }}
                                width="100%"
                                height="100%"
                            />                                                              
                            </Box>
                        </Grid>      
                    </Grid>
            </Container>
        </Box>
    </StyledBox>
  );
};

export { HeroSection };